'use client'

import { useEffect } from 'react'

export function HeadingAnchors({ headingIds }: { headingIds: string[] }) {
  useEffect(() => {
    const container = document.querySelector('#content') || document
    if (!container) return

    const headings = Array.from(
      container.querySelectorAll<HTMLHeadingElement>('h1, h2, h3, h4, h5, h6'),
    )

    let idx = 0
    headings.forEach((h) => {
      if (h.tagName.toLowerCase() === 'h1') return
      const id = headingIds[idx]
      if (id) {
        h.id = id
        idx += 1
      }
    })
  }, [headingIds])

  return null
}
